/**
 * Copyright (c) 2026 Finorda Pty Ltd
 * All rights reserved.
 *
 * This file is part of the Finorda platform.
 * Unauthorised copying, modification or
 * distribution of this software is
 * strictly prohibited.
 *
 * Proprietary and confidential.
 * Governed by Queensland law, Australia.
 */

import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

function Layout() {
  const { user, logout, isPanelok, isPanelokAdmin } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <div className="app-container" data-testid="pog-layout">
      <aside className="sidebar" data-testid="pog-sidebar">
        <div className="sidebar-header">
          <h1>Panelok POG</h1>
          <span>Purchase Order Generator</span>
        </div>

        <nav data-testid="pog-nav">
          <ul className="sidebar-nav">
            <li>
              <NavLink to="/" end data-testid="nav-dashboard">Dashboard</NavLink>
            </li>
            <li>
              <NavLink to="/csv-upload" data-testid="nav-csv-upload">CSV Upload</NavLink>
            </li>
            <li>
              <NavLink to="/purchase-orders" data-testid="nav-purchase-orders">Purchase Orders</NavLink>
            </li>
            {isPanelok() && (
              <>
                <li>
                  <NavLink to="/manual-po" data-testid="nav-manual-po">Manual PO</NavLink>
                </li>
                <li>
                  <NavLink to="/window-po" data-testid="nav-window-po">Window/Door PO</NavLink>
                </li>
              </>
            )}
            <li>
              <NavLink to="/items" data-testid="nav-items">Items</NavLink>
            </li>
            {isPanelokAdmin() && (
              <li>
                <NavLink to="/suppliers" data-testid="nav-suppliers">Supplier Mapping</NavLink>
              </li>
            )}
          </ul>
        </nav>

        <div style={{ position: 'absolute', bottom: 20, left: 20, right: 20 }}>
          <div style={{ marginBottom: 10, fontSize: '0.85rem', opacity: 0.8 }} data-testid="user-email">
            {user?.email}
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="btn btn-outline"
            style={{ width: '100%', color: 'white', borderColor: 'rgba(255,255,255,0.3)' }}
          >
            Logout
          </button>
        </div>
      </aside>

      <main className="main-content" data-testid="pog-main-content">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
